import { ApiBaseFront } from "../../front/api-base-front";

type Params = {
  kijshopCd: string,
};

export class ApiPrintFavoriteFolderListGet extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
    } = param;

    super(
      'GET',
      `/api/v1/print/shop/${kijshopCd}/favfolder`,
      'JSON',
      {},
    );
  }
}
